import { Injectable, EventEmitter } from '@angular/core';
import { RequestMethodsService } from '../commons/request_methods';
import { Constants } from '../commons/constants';

@Injectable()
export class AlertService {
    public systems: string[] = [];
    public systemEventEmitter = new EventEmitter();
    public showOnboardDiagnostics = new EventEmitter();
    constructor(
        private requestMethodService: RequestMethodsService,
        private constants: Constants
    ) {
    }

    getDiagnosticAlerts(token, assetId, duration, lang) {
        let API_URL = window.sessionStorage.getItem('isNetCoreUser') === "true" ? this.constants.NETCORE_BASE_URL : this.constants.LEGACY_BASE_URL;
        return this.requestMethodService.get(
            token,
            API_URL,
            this.constants.GET_DIAGNOSTIC_ALERTS,
            {
                id: assetId,
                duration: duration,
                lang: lang
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/services/alert.service.ts